import styles from './channelherocard.module.scss';
import { ComponentProps } from 'react';
import { StaticChannel } from '../StaticChannel';
import cn from 'classnames';
import { AudioIcon } from '@/ui-components/atoms/AnimatedIcons/AudioIcon/AudioIcon';
import { Text } from '@/ui-components/atoms/Text/Text';

export interface ChannelHeroProps {
    color: string;
    channelCardProps: ComponentProps<typeof StaticChannel>;
    className?: string;
}

export default function ChannelHeroCard({ channelCardProps, color, className }: ChannelHeroProps) {
    return (
        <div className={cn(styles.channelWrapper, className)}>
            <div className={styles.ChannelTextWrapper}>
                <div className={styles.audioIconWrapper}>
                    <div>
                        <span>Now Playing</span> <AudioIcon fillColor={color} />
                        <div className={styles.mobileAlbum}>
                            <Text tag="div">{channelCardProps.title}</Text>
                            <Text tag="div">{channelCardProps.subTitle}</Text>
                        </div>
                    </div>
                </div>
                <StaticChannel {...channelCardProps} />
            </div>
        </div>
    );
}
